if (!customElements.get('ss-cart-trust')) {
  customElements.define('ss-cart-trust', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-ss-trust-rail]');
      if (!this.rail) return;

      this.slides = Array.from(this.rail.children);
      if (this.slides.length < 2) return;

      this.dotsEl = this.querySelector('[data-ss-trust-dots]');
      this.delay = Number(this.dataset.delay) || 3500;
      this.wantsAutoplay = this.dataset.autoplay === 'true' && !SS.reduceMotion();

      this.onScroll = SS.rafThrottle(this.syncDots.bind(this));
      this.onPause = () => this.pause();
      this.onResume = () => this.resume();

      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      this.buildDots();
      this.syncDots();

      if (!this.wantsAutoplay) return;

      this.rail.addEventListener('pointerdown', this.onPause);
      this.rail.addEventListener('pointerup', this.onResume);
      this.rail.addEventListener('pointercancel', this.onResume);
      this.addEventListener('mouseenter', this.onPause);
      this.addEventListener('mouseleave', this.onResume);

      // Ne tourne que si le tiroir est ouvert et visible
      this.io = new IntersectionObserver(([entry]) => {
        entry.isIntersecting ? this.start() : this.stop();
      }, { threshold: 0.5 });
      this.io.observe(this);

      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    disconnectedCallback() {
      this.stop();
      this.io?.disconnect();
      this.rail?.removeEventListener('scroll', this.onScroll);
      this.rail?.removeEventListener('pointerdown', this.onPause);
      this.rail?.removeEventListener('pointerup', this.onResume);
      this.rail?.removeEventListener('pointercancel', this.onResume);
      this.removeEventListener('mouseenter', this.onPause);
      this.removeEventListener('mouseleave', this.onResume);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    start() {
      if (this.timer || this.paused || !this.wantsAutoplay) return;
      this.timer = setInterval(() => this.next(), this.delay);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    pause() { this.paused = true; this.stop(); }
    resume() { this.paused = false; this.start(); }

    next() {
      this.goTo((this.currentIndex() + 1) % this.slides.length);
    }

        currentIndex() {
      const pos = this.rail.scrollLeft;
      let best = 0;
      let min = Infinity;

      this.slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - this.rail.offsetLeft - pos);
        if (dist < min) { min = dist; best = i; }
      });
      return best;
    }

    goTo(index) {
      const slide = this.slides[index];
      if (!slide) return;
      this.rail.scrollTo({
        left: slide.offsetLeft - this.rail.offsetLeft,
        behavior: SS.reduceMotion() ? 'auto' : 'smooth'
      });
    }

    buildDots() {
      if (!this.dotsEl) return;

      // Opt-out explicite plutôt qu'opt-in : une valeur vide affiche les puces
      if (this.dataset.dots === 'false') {
        this.dotsEl.setAttribute('hidden', '');
        return;
      }

      this.dotsEl.innerHTML = '';
      this.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ss-cd__trust-dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Argument ${i + 1} sur ${this.slides.length}`);
        dot.addEventListener('click', () => {
          this.pause();
          this.goTo(i);
          setTimeout(() => this.resume(), this.delay);
        });
        this.dotsEl.appendChild(dot);
      });

      this.dots = Array.from(this.dotsEl.children);
      this.dotsEl.removeAttribute('hidden');
    }

    syncDots() {
      const index = this.currentIndex();
      this.dots?.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }
  });
}

/* --- Reconstruction après re-rendu du tiroir par Horizon --- */
(function () {
  if (window.__ssCartTrustWatch) return;
  window.__ssCartTrustWatch = true;

  function rebuild() {
    document.querySelectorAll('ss-cart-trust').forEach((el) => {
      const dotsEl = el.querySelector('[data-ss-trust-dots]');
      // Déjà construit sur ce nœud : rien à faire
      if (dotsEl && dotsEl.children.length > 0) return;
      if (typeof el.connectedCallback === 'function') el.connectedCallback();
    });
  }

  const run = () => requestAnimationFrame(() => setTimeout(rebuild, 80));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('ss:cart:update', run);
  document.addEventListener('shopify:section:load', run);

  // Le tiroir est re-rendu par morphing : on surveille son conteneur
  function watch() {
    const inner = document.querySelector('.cart-drawer__inner');
    if (!inner || inner.dataset.ssTrustWatched) return;
    inner.dataset.ssTrustWatched = 'true';
    new MutationObserver(() => run()).observe(inner, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  document.addEventListener('shopify:section:load', watch);
})();